import { FC } from 'react';
import { DialogSessionActions } from '@/features/DialogSession';

type Props = {
  time: string;
  children: React.ReactNode;
  className?: string;
};

export const TimeFragmentLink: FC<Props> = ({ time, children, className }) => {
  return (
    <DialogSessionActions clickAction={'scrollTo'} actions={['play', 'stop']} time={time} className={className}>
      {children}
    </DialogSessionActions>
  );
};
